import { render, staticRenderFns } from "./CbsEcommerceMedal.vue?vue&type=template&id=04431f92"
import script from "./CbsEcommerceMedal.vue?vue&type=script&lang=js"
export * from "./CbsEcommerceMedal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports